<template>
  <div class="comment-image me-3" :class="isMenu ? 'd-flex profile-pic' : 'd-none d-md-flex' ">
    <img :src="imageSource"
      :class="cssClass"
      :alt="userName"
      class="img-fluid rounded-circle"
      width="30"
      height="30"
      />
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue'
import CONFIG from '@/config/config'
import { testImage } from '@/utils/imageUtils';


export default defineComponent({
  name: 'UserProfilePicture',
  props: {
    userEmail: String,
    userName: String,
    cssClass: String,
    fallbackImgkUrl: String,
    isMenu: { type: Boolean, default: false }
  },
  data() {
    let imageBaseurl = CONFIG.baseUrl;
    if(imageBaseurl === "/"){
      imageBaseurl = "";
    }
    return {
      url: CONFIG.baseUrl,
      imageSource: imageBaseurl + '/.resources/bcisa-vue/resources/img/userpic-placeholder.jpg',
    };
  },
  mounted() {
    //this.loadUserImage(this.url + '.imaging/awu/brz-intranet/test_awu/' + this.userEmail + '.jpg')
  },
  updated() {
    //this.loadUserImage(this.url + '.imaging/awu/brz-intranet/test_awu/' + this.userEmail + '.jpg')
  },
  methods: {
    loadUserImage(url: string): void {
      if(this.userEmail !== undefined) {
        testImage(url).then(() => {
          this.imageSource = url
        }).catch(() => {
          // not empty (linting...)
        })
        // new Promise(function imgPromise(resolve, reject): any {
        //   const imgElement = new Image();
        //   imgElement.addEventListener('load', function imgOnLoad() {
        //     resolve(this);
        //   });
        //   imgElement.addEventListener('error', function imgOnError() {
        //     reject();
        //   })
        //   imgElement.src = url;
        // }).then(() => {
        //   this.imageSource = url
        // }).catch(() => {
        // })
      }
    }
  }
});
</script>
